"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateFormat = void 0;
let DateFormat = exports.DateFormat = /*#__PURE__*/function (DateFormat) {
  // cs-CZ example: "dddd d. MMMM yyyy H:mm:ss"
  DateFormat[DateFormat["FullDateTime"] = 0] = "FullDateTime";
  // cs-CZ example: "dddd d. MMMM yyyy"
  DateFormat[DateFormat["LongDate"] = 1] = "LongDate";
  // cs-CZ example: "H:mm:ss"
  DateFormat[DateFormat["LongTime"] = 2] = "LongTime";
  // cs-CZ example: "d. MMMM"
  DateFormat[DateFormat["MonthDay"] = 3] = "MonthDay";
  // cs-CZ example: "dd.MM.yyyy"
  DateFormat[DateFormat["ShortDate"] = 4] = "ShortDate";
  // cs-CZ example: "dd.MM.yyyy H:mm:ss"
  DateFormat[DateFormat["ShortDateLongTime"] = 5] = "ShortDateLongTime";
  // cs-CZ example: "dd.MM.yyyy H:mm"
  DateFormat[DateFormat["ShortDateTime"] = 6] = "ShortDateTime";
  // cs-CZ example: "H:mm"
  DateFormat[DateFormat["ShortTime"] = 7] = "ShortTime";
  // cs-CZ example: "yyyy'-'MM'-'dd'T'HH':'mm':'ss"
  DateFormat[DateFormat["SortableDateTime"] = 8] = "SortableDateTime";
  // cs-CZ example: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'"
  DateFormat[DateFormat["UniversalSortableDateTime"] = 9] = "UniversalSortableDateTime";
  // cs-CZ example: "MMMM yyyy"
  DateFormat[DateFormat["YearMonth"] = 10] = "YearMonth";
  // Custom date format pattern
  DateFormat[DateFormat["Custom"] = 11] = "Custom";
  return DateFormat;
}({});
//# sourceMappingURL=DateFormat.js.map